// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1ezWE","additionalInfo":"AgreementModal_additionalInfo__1bAqQ"};